<template>
  <!-- Main Sidebar Container -->
  <aside class="main-sidebar sidebar-dark-primary elevation-4">
    <!-- Brand Logo -->
    <router-link :to="{ name: 'home', params: { locale } }" class="brand-link">
      <img
        src="@/assets/images/logo.jpg"
        alt="Juzgado PCyF 10"
        class="brand-image img-circle elevation-3"
        style="opacity: 0.8"
      />
      <span class="brand-text font-weight-light">Juzgado PCyF 10</span>
    </router-link>

    <!-- Sidebar -->
    <div class="sidebar">
      <!-- Sidebar Menu -->
      <nav class="mt-2">
        <ul
          class="nav nav-pills nav-sidebar flex-column"
          data-widget="treeview"
          role="menu"
          data-accordion="false"
        >
          <template v-if="!$screen.sm">
            <li class="nav-item">
              <router-link
                :to="{ name: 'home', params: { locale } }"
                class="nav-link text-white"
              >
                {{ $t("inicio") }}</router-link
              >
            </li>
            <li class="nav-item">
              <router-link
                :to="{ name: 'contacto', params: { locale } }"
                class="nav-link text-white"
              >
                {{ $t("contacto") }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                :to="{ name: 'ubicacion', params: { locale } }"
                class="nav-link text-white"
              >
                {{ $t("ubicacion") }}
              </router-link>
            </li>
          </template>

          <!-- Add icons to the links using the .nav-icon class
          with font-awesome or any other icon font library-->
          <li class="nav-item has-treeview menu-open">
            <a
              href="#"
              class="nav-link"
              :class="{ active: subIsActive('/resoluciones/') }"
            >
              <i class="nav-icon far fa-copy"></i>
              <span>
                {{ $t("Resoluciones") }}
                <i class="fas fa-angle-left right"></i>
              </span>
            </a>

            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link
                  :to="{ name: 'resoluciones2016-2024', params: { locale } }"
                  class="nav-link"
                  active-class="active"
                >
                  <i class="far fa-circle nav-icon"></i>
                  <span>2016 - 2024</span>
                </router-link>
              </li>
              <li
                v-for="(year, index) in resolucionesYear"
                :key="index"
                class="nav-item"
              >
                <router-link
                  :to="{ name: 'resoluciones', params: { year, locale } }"
                  class="nav-link"
                  active-class="active"
                >
                  <i class="far fa-circle nav-icon"></i>
                  <span>{{ year }}</span>
                </router-link>
              </li>
            </ul>
          </li>

          <li class="nav-item">
            <router-link
              :to="{ name: 'integrantes', params: { locale } }"
              class="nav-link"
              active-class="active"
            >
              <i class="nav-icon far fa-address-card"></i>
              <span>{{ $t("CVs") }}</span>
            </router-link>
          </li>

          <template v-if="isEnglish">
            <li class="nav-header">ARTICLES</li>
            <li class="nav-item">
              <a
                class="nav-link"
                target="_blank"
                href="https://oecd-opsi.org/innovations/transparency-in-the-justice-system-an-obligation-and-an-opportunity/"
                ><i class="fas fa-external-link-alt"></i> OECD OPSI</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                target="_blank"
                href="https://apolitical.co/en/solution_article/open-justice-pioneering-buenos-aires"
                ><i class="fas fa-external-link-alt"></i> Rebuilding Trust</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                target="_blank"
                href="https://apolitical.co/en/solution_article/keeping-justice-alive-during-the-pandemic"
                ><i class="fas fa-external-link-alt"></i> Justice during
                pandemic</a
              >
            </li>
          </template>

          <li class="nav-header">{{ $t("Documentos") }}</li>
          <li class="nav-item">
            <router-link
              :to="{ name: 'lenguaje', params: { locale } }"
              class="nav-link"
              active-class="active"
            >
              <i class="nav-icon fas fa-balance-scale"></i>
              <span v-html="$t('Lenguaje Claro')"></span>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link
              :to="{ name: 'manual', params: { locale } }"
              class="nav-link"
              active-class="active"
            >
              <i class="nav-icon far fa-file-alt"></i>
              <span v-html="$t('Manual de Procedimientos')"></span>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link
              :to="{ name: 'planificacion', params: { locale } }"
              class="nav-link user-panel"
              active-class="active"
            >
              <i class="nav-icon fas fa-file-alt"></i>
              <span v-html="$t('Planificacion')"></span>
            </router-link>
          </li>
        </ul>
      </nav>
      <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
  </aside>
</template>

<script>
const resolucionesYear = [2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016];

export default {
  data() {
    return {
      resolucionesYear,
    };
  },
  computed: {
    isEnglish() {
      return this.$i18n.locale === "en";
    },
  },
  methods: {
    subIsActive(input) {
      return this.$route.path.indexOf(input) >= 0;
    },
  },
};
</script>

<style></style>

<i18n>
{
  "es": {
    "inicio" : "Inicio",
    "contacto": "Contacto",
    "ubicacion" : "Ubicación",
    "Resoluciones": "Resoluciones",
    "CVs" : "CV de los Integrantes",
    "Documentos" : "DOCUMENTOS",
    "Lenguaje Claro" : "Lenguaje Claro",
    "Manual de Procedimientos" :"Manual de Procedimientos",
    "Planificacion" : "Planificación",
    "Historico": "Histórico"
  },
  "en": {
    "inicio" : "Home",
    "contacto": "Contact",
    "ubicacion" : "Location",
    "Resoluciones": "Rulings Issued",    
    "CVs" : "Team CV's",
    "Documentos" : "DOCUMENTS",
    "Lenguaje Claro" : "Plain Language and Style <br/> Guide",
    "Manual de Procedimientos" :"Procedure & Management <br/> Manual",
    "Planificacion" : "Objectives and Planning <br/> Guide",
    "Historico": "Historical"
  }
}
</i18n>
